
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'SampleDataBadge'
})
export default class SampleDataBadge extends Vue {
  @Prop({ required: true, type: Boolean })
  isSampleData!: boolean;
}
